/* mio-collection-nav-ajax.js
   No-reload navigation for the collection sub-nav tiles (dynamic-collection-list).

   Tapping a tile fetches the target collection and swaps only the product-grid
   pieces (#ProductGridContainer + facets + counts), leaving the nav DOM (and its
   Splide carousel scroll position) untouched. The persistent xFiltersAndSortby
   component keeps working because every ring collection shares one template /
   section.id, so its section-render fetches still resolve after navigation.

   Falls back to a normal full navigation if anything is missing or the fetch fails. */
(function () {
  'use strict';

  var NAV_SEL = '.x-container-collection-list';
  var GRID_ID = 'ProductGridContainer';
  var COUNT_IDS = ['ProductCount', 'ProductCount_header', 'ProductCountDrawer'];
  var FACET_SELS = ['.form-aside', '.form-drawer'];

  var reqToken = 0;

  function pathOf(u) { try { return new URL(u, location.href).pathname; } catch (e) { return u; } }
  function sameOrigin(u) { try { return new URL(u, location.href).origin === location.origin; } catch (e) { return false; } }

  /* Dimming the grid to 0.5 while the next page loads washes out real product
     photography, and a half-faded ring reads as an image that failed rather
     than as work in progress. Hold the current grid at full strength — it is
     still perfectly good content — and fade the replacement in instead. */
  function loading(on) {
    var g = document.getElementById(GRID_ID);
    if (!g) return;
    g.style.pointerEvents = on ? 'none' : '';
    g.setAttribute('aria-busy', on ? 'true' : 'false');
    var heading = document.querySelector(NAV_SEL + ' .x-block-header');
    var status = document.querySelector('[data-mio-collection-status]');
    if (on && heading && !status) {
      status = document.createElement('span');
      status.className = 'mio-collection-status';
      status.setAttribute('data-mio-collection-status', '');
      status.setAttribute('role', 'status');
      status.textContent = 'Loading collection…';
      heading.appendChild(status);
    } else if (!on && status) {
      status.remove();
    }
  }

  function fadeIn(el) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.style.transition = 'none';
      el.style.opacity = '1';
      return;
    }
    el.style.transition = 'none';
    el.style.opacity = '0';
    requestAnimationFrame(function () {
      el.style.transition = 'opacity .22s ease';
      el.style.opacity = '1';
    });
  }

  function swapById(doc, id) {
    var s = doc.getElementById(id), d = document.getElementById(id);
    if (s && d) {
      d.innerHTML = s.innerHTML;
      if (id === GRID_ID) fadeIn(d);
      return true;
    }
    return false;
  }
  function swapSel(doc, sel) {
    var s = doc.querySelector(sel), d = document.querySelector(sel);
    if (s && d) { d.innerHTML = s.innerHTML; return true; }
    return false;
  }

  /* The filter toolbar renders OUTSIDE #ProductGridContainer, so it survived
     every swap carrying the previous collection's Shape / Size / Metal values —
     the shopper moved from one collection to another and was offered filters
     that match nothing here. syncFromUrl() in the toolbar only re-ticks inputs
     that already exist; it cannot replace the option lists themselves.

     Not a plain swapSel: mio-filter-toolbar.js moves the sheet out to <body> to
     escape the sticky bar's backdrop-filter, so by now it is no longer inside
     the shell we are replacing. Left alone, the incoming markup's sheet becomes
     a second one and the old listeners keep pointing at a detached node. */
  function swapFilterToolbar(doc) {
    var src = doc.querySelector('.mio-ft-shell');
    var dst = document.querySelector('.mio-ft-shell');
    if (!src || !dst) return false;

    var orphan = document.body.querySelector(':scope > [data-ft-sheet]');
    if (orphan) orphan.parentNode.removeChild(orphan);
    // A sheet open at the moment of navigation would otherwise leave the lock on.
    document.documentElement.classList.remove('mio-ft-sheet-open');

    dst.innerHTML = src.innerHTML;
    return true;
  }

  function updateActive(url) {
    var nav = document.querySelector(NAV_SEL);
    if (!nav) return;
    var target = pathOf(url);
    // Re-highlight ONLY — never scroll or move the carousel. The tiles keep their
    // order and scroll position exactly as the user left them; the current tile
    // just gains the active border in place.
    nav.querySelectorAll('a.collection-card').forEach(function (a) {
      var on = pathOf(a.getAttribute('href') || '') === target;
      a.classList.toggle('border-collection', on);
      a.classList.toggle('border-collection-initial', !on);
    });
  }

  function go(url, push) {
    updateActive(url);            // OPTIMISTIC: highlight the tapped tile immediately
    /* The heading is NOT swapped optimistically any more. Measured on live: it
       changed at 120ms while the products underneath it did not change until
       2,000ms — for nearly two seconds the page claimed to be one collection
       while showing another, and the breadcrumb still said a third thing. The
       tile's active border is honest immediate feedback; the title is a claim
       about the content, so it now waits for the content. */
    loading(true);
    var token = ++reqToken;       // only the most recent tap gets to swap the grid
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (text) {
        if (token !== reqToken) return; // a newer tap superseded this one
        var doc = new DOMParser().parseFromString(text, 'text/html');
        if (!doc.getElementById(GRID_ID)) throw new Error('no product grid in response');
        swapById(doc, GRID_ID);
        FACET_SELS.forEach(function (sel) { swapSel(doc, sel); });
        swapFilterToolbar(doc);
        COUNT_IDS.forEach(function (id) { swapById(doc, id); });
        // Collection heading + breadcrumb also depend on the collection. Swap the nav
        // section's HEADER (the "{{ collection.title }}" heading) — but not the tile
        // carousel (.x-block-list) beside it — and the breadcrumb banner above it.
        swapSel(doc, NAV_SEL + ' .x-block-header');
        swapSel(doc, '[id*="main_collection_banner"]');
        var t = doc.querySelector('title'); if (t) { document.title = t.textContent; }
        if (push) { history.pushState({ mioColl: 1, url: url }, '', url); }
        updateActive(url);          // reconcile (covers Splide clones added after the tap)
        loading(false);
        window.dispatchEvent(new CustomEvent('mio:collection-swapped', { detail: { url: url } }));
      })
      .catch(function () {
        if (token === reqToken) { window.location.href = url; } // hard fallback
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest(NAV_SEL + ' a.collection-card');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || !sameOrigin(href) || a.getAttribute('target') === '_blank') return;
    if (!document.getElementById(GRID_ID)) return;         // nothing to swap -> let the browser navigate
    if (pathOf(href) === location.pathname) { e.preventDefault(); return; } // already here
    e.preventDefault();
    go(href, true);
  }, false);

  window.addEventListener('popstate', function (e) {
    /* A sheet dismissing itself via Back pushes and pops an entry on the SAME
       url (see mio-sheet.js). Without this guard that pop reads as a navigation
       and refetches the collection we are already on. */
    if (e && e.state && e.state[(window.MioSheet && window.MioSheet.STATE_KEY) || 'mioSheet']) return;
    // Re-sync to the URL we're now on (Back/Forward). Guard to our SPA context:
    // only act when the nav + grid are actually present. Don't rely on
    // history.state (the theme's search/pagination scripts overwrite it).
    if (document.querySelector(NAV_SEL) && document.getElementById(GRID_ID)) {
      go(location.href, false);
    }
  });

  // Seed the current entry so the first Back returns here via the same path.
  if (!history.state || !history.state.mioColl) {
    try { history.replaceState(Object.assign({}, history.state || {}, { mioColl: 1, url: location.href }), '', location.href); } catch (err) {}
  }
})();
